import {
  CreateMerchantUserRequest,
  MerchantUser,
  MerchantUserRole,
  UpdateMerchantUserRequest,
} from 'APIs/merchant.users/merchant.users.types';

export const defaultUserRole = 'support' as MerchantUserRole;

export type UserFormProps = {
  userId: string | null;
  email: string;
  role: MerchantUserRole | '';
  enabled: boolean;
  sendEmail: boolean;
};

type ToCreateMerchantUserRequest = (merchantId: string, userForm: UserFormProps) => CreateMerchantUserRequest;
type ToUpdateMerchantUserRequest = (merchantId: string, userForm: UserFormProps) => UpdateMerchantUserRequest;
type ToUserFormProps = (user: MerchantUser) => UserFormProps;

export const toCreateMerchantUserRequest: ToCreateMerchantUserRequest = (
  merchantId: string,
  userForm: UserFormProps,
): CreateMerchantUserRequest => {
  return {
    emailAddress: userForm.email,
    merchantId,
    merchantUserRole: userForm.role ? userForm.role : defaultUserRole,
    sendOnboardingEmail: userForm.sendEmail,
  };
};

export const toUpdateMerchantUserRequest: ToUpdateMerchantUserRequest = (
  merchantId: string,
  userForm: UserFormProps,
): UpdateMerchantUserRequest => {
  return {
    emailAddress: userForm.email,
    merchantId,
    merchantUserRole: userForm.role ? userForm.role : defaultUserRole,
    status: userForm.enabled ? 'enabled' : 'disabled',
  };
};

export const toUserFormProps: ToUserFormProps = (user: MerchantUser): UserFormProps => {
  return {
    userId: user._id,
    email: user.emailAddress,
    role: user.merchantUserRole,
    enabled: user.status === 'enabled',
    sendEmail: false,
  };
};
